import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  extendedTitleLabel: {
    id: 'course-authoring.schedule-section.introducing.title.label',
    defaultMessage: 'Course title',
  },
  extendedTitleHelpText: {
    id: 'course-authoring.schedule-section.introducing.title.help-text',
    defaultMessage: 'Displayed as title on the course details page. Limit to 50 characters.',
  },
  extendedTitleAriaLabel: {
    id: 'course-authoring.schedule-section.introducing.title.aria-label',
    defaultMessage: 'Show course title',
  },
  extendedSubtitleLabel: {
    id: 'course-authoring.schedule-section.introducing.subtitle.label',
    defaultMessage: 'Course subtitle',
  },
  extendedSubtitleHelpText: {
    id: 'course-authoring.schedule-section.introducing.subtitle.help-text',
    defaultMessage: 'Displayed as subtitle on the course details page. Limit to 150 characters.',
  },
  extendedSubtitleAriaLabel: {
    id: 'course-authoring.schedule-section.introducing.subtitle.aria-label',
    defaultMessage: 'Show course subtitle',
  },
  extendedDurationLabel: {
    id: 'course-authoring.schedule-section.introducing.duration.label',
    defaultMessage: 'Course duration',
  },
  extendedDurationHelpText: {
    id: 'course-authoring.schedule-section.introducing.duration.help-text',
    defaultMessage: 'Displayed on the course details page. Limit to 50 characters.',
  },
  extendedDurationAriaLabel: {
    id: 'course-authoring.schedule-section.introducing.duration.aria-label',
    defaultMessage: 'Show course duration',
  },
  extendedDescriptionLabel: {
    id: 'course-authoring.schedule-section.introducing.description.label',
    defaultMessage: 'Course description',
  },
  extendedDescriptionHelpText: {
    id: 'course-authoring.schedule-section.introducing.description.help-text',
    defaultMessage: 'Displayed on the course details page. Limit to 1000 characters.',
  },
  extendedDescriptionAriaLabel: {
    id: 'course-authoring.schedule-section.introducing.description.aria-label',
    defaultMessage: 'Show course description',
  },
});

export default messages;
